import { motion } from "framer-motion";
import { CreditCard, CalendarX } from "lucide-react";
import { reveal, revealContainer, viewportOnce } from "../../lib/motion";

const PAYMENT = [
  { label: "Orders under NZ$300", value: "Full payment is required at the time of booking." },
  { label: "Orders of NZ$300 or more", value: "A 50% deposit is required to secure your booking. The remaining balance is due 3 days before your event." },
  { label: "Corporate clients", value: "Approved business accounts may pay by invoice within 7 days of delivery." },
];

const CANCELLATION = [
  "Deposits are non-refundable for cancellations made within 7 days of the event.",
  "If you need to change your booking, please contact us as early as possible. We will do our best to accommodate changes where possible.",
];

export const BookingPayment = () => (
  <section data-testid="booking-section" className="bg-cream py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20">
      <motion.div
        variants={revealContainer}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
      >
        <motion.div variants={reveal} className="flex items-center gap-4 mb-8">
          <CreditCard className="text-gold" size={28} strokeWidth={1.4} aria-hidden="true" />
          <div>
            <span className="label-caps text-sage">Booking &amp; Payment</span>
            <h2 className="mt-1 font-serif text-3xl md:text-4xl text-ink">Confirming your booking</h2>
          </div>
        </motion.div>
        <div className="border-t border-ink/15">
          {PAYMENT.map((p) => (
            <motion.div key={p.label} variants={reveal} className="py-6 border-b border-border">
              <h3 className="font-serif text-xl md:text-2xl text-ink">{p.label}</h3>
              <p className="mt-1.5 text-ink/60 leading-relaxed max-w-lg">{p.value}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>

      <motion.div
        variants={revealContainer}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
      >
        <motion.div variants={reveal} className="flex items-center gap-4 mb-8">
          <CalendarX className="text-gold" size={28} strokeWidth={1.4} aria-hidden="true" />
          <div>
            <span className="label-caps text-sage">Cancellation Policy</span>
            <h2 className="mt-1 font-serif text-3xl md:text-4xl text-ink">Changes &amp; cancellations</h2>
          </div>
        </motion.div>
        <motion.div variants={reveal} className="bg-surface border border-border p-8 md:p-10 space-y-6">
          {CANCELLATION.map((c) => (
            <p key={c} className="text-ink/70 leading-relaxed flex gap-3">
              <span className="text-gold mt-1">&#10022;</span>
              <span>{c}</span>
            </p>
          ))}
        </motion.div>
      </motion.div>
    </div>
  </section>
);
